function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  padding: 5px 7px;\n\n  p {\n    margin: 0 0 6px 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  max-width: 300px;\n  span > {\n    display: flex;\n    justity-content: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 15px;\n  font-weight: 400;\n  align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  width: 15%;\n  display: flex;\n  align-items: center;\n  color: #000;\n  font-size: 14px;\n  font-family: Open Sans;\n  font-style: normal;\n  font-weight: 400;\n  margin-right: 15px;\n  word-break: break-word;\n\n  ",
        " {\n    width: 25%;\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  width: ",
        "%;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  color: #000;\n  font-size: 14px;\n  font-family: Open Sans;\n  font-style: normal;\n  margin-left: 15px;\n  word-break: break-word;\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  margin-right: 10px;\n  width: 32px;\n  height: 32px;\n  border-radius: 3px;\n  cursor: pointer;\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  flex: 1;\n  position: relative;\n  min-height: 32px;\n  border-radius: 5px;\n  overflow: hidden;\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  height: 100%;\n  display: flex;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  padding: 0 15px;\n  width: 100%;\n  justify-content: space-between;\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  flex: 1;\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  background: ",
        ";\n  width: ",
        "%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 0px;\n  overflow: hidden;\n\n  > div {\n    visibility: hidden;\n  }\n\n  div:first-of-type {\n    border-top-left-radius: 5px;\n    border-bottom-left-radius: 5px;\n  }\n\n  div:last-of-type {\n    border-top-right-radius: 5px;\n    border-bottom-right-radius: 5px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  overflow: hidden;\n  visibility: initial;\n  white-space: nowrap;\n  padding: 0 5px;\n  font-weight: 400;\n  color: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  min-height: 32px;\n  overflow: hidden;\n  display: flex;\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n      margin: 0 0 0 0;\n    "
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 40px;\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  margin: 0 25px 25px 0;\n  flex-wrap: wrap;\n  > span {\n    margin-left: 8px;\n  }\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  margin-right: 0;\n  border-radius: 4px;\n  padding: 7px 10px;\n  background: ",
        ";\n  height: 32px;\n  font-weight: 400;\n  color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  width: 14px;\n  height: 14px;\n  margin-right: 5px;\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex: 1 0 auto;\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  width: 40%;\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  margin-right: 8px;\n  ",
        " {\n    margin-right: 8px;\n    max-width: 100%;\n    width: 100%;\n    min-width: auto;\n  }\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  max-height: 400px;\n  overflow: scroll;\n  border-radius: 5px;\n  border: 1px solid #d5d5d5;\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
import { css } from '@tapresearch/ui/components';
import styled from '@emotion/styled';
import { darken } from 'polished';
import { mediaBreakpointDown } from 'Shared/Utility';
import ReactTooltip from 'Shared/Tooltip';
import Select from '../../common/Select';
export var COLORS = [
    '#D4F2D1',
    '#A6B8DC',
    '#F5C9BB',
    '#a6cee3',
    '#3892ce',
    '#b2df8a',
    '#47b240',
    '#fb9a99',
    '#dd4647',
    '#fdbf6f',
    '#ff7f00',
    '#cab2d6'
];
export var Tooltip = styled(ReactTooltip)(_templateObject());
export var RankHelpTooltip = styled(ReactTooltip)(_templateObject1());
export var Row = styled.div(_templateObject2());
export var RowLabel = styled.div(_templateObject3(), mediaBreakpointDown('xs'));
export var CrossTabRow = styled.div(_templateObject4(), function(props) {
    return props.percentage || 100;
});
export var BarRowLabel = styled.div(_templateObject5());
export var RowThumbImage = styled.img(_templateObject6());
export var RowBar = styled.div(_templateObject7(), function(props) {
    return props.grayBg && "\n    background: #FAFAFA;\n  ";
});
export var BarLabel = styled.div(_templateObject8());
export var BarLabelContent = styled.div(_templateObject9());
export var BarItem = styled.div(_templateObject10(), function(props) {
    return props.background || '#D4F2D1';
}, function(props) {
    return props.percentage || 0;
});
export var BarItemLabel = styled.div(_templateObject11(), function(props) {
    return props.color ? darken(0.55, props.color) : '#000';
});
export var Bar = styled.div(_templateObject12());
export var LegendContainer = styled.div(_templateObject14(), function(props) {
    return props.noMargin && css(_templateObject13());
});
export var LegendItem = styled.div(_templateObject15());
export var Legend = styled.button(_templateObject16(), function(props) {
    return props.background;
}, function(props) {
    return props.background ? darken(0.55, props.background) : '#000';
});
export var LegendIcon = styled.img(_templateObject17());
export var ChartRowTitle = styled.div(_templateObject18());
export var ChartRowItem = styled.div(_templateObject19());
export var TabSelect = styled(Select)(_templateObject20(), mediaBreakpointDown('xs'));
export var getBarLabelColor = function(idx) {
    if (idx < COLORS.length) return COLORS[idx];
    var colorIdx = idx % COLORS.length;
    var darkenFactor = Math.floor(idx / COLORS.length);
    return darken(0.1 * darkenFactor, COLORS[colorIdx]);
};
export var TableContainer = styled.div(_templateObject21());
export var AverageRatingStyles = {
    align: 'center',
    mb: '30px',
    justifyContent: 'center',
    fontWeight: 'bold',
    fontSize: 'lg',
    mr: '15px'
};
